module.exports = "/assets/site/images/teke.jpg?a0d16e25e722553510f243e68ccb79ba";